import React from 'react';
import Row from "./Row";
const AlternatingLayout = props => /*#__PURE__*/React.createElement("section", null, props.children);
AlternatingLayout.Row = Row;
export default AlternatingLayout;